import React, { Component } from "react";
import { Title } from "../Styles";
import { HoverButton } from "./Styles/Platform.style";
import { TextBox } from "../Shared/FormHelpers";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";

const Button = styled.i`
  color: #0071bc;
`;

export default class EducationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      education: [
        {
          institution: "",
          education_type: "high school",
          city_state: "",
          country: "",
          profile_id: this.props.profile.id,
        },
      ],
      updatedEducation: new Set(),
      loaded: false,
    };
  }

  componentWillReceiveProps(props) {
    this.props.profile &&
      this.props.profile.educations &&
      !this.state.loaded &&
      this.setState({
        education: [...props.profile.educations, ...this.state.education],
        loaded: true,
      });
  }

  addEducation = () => {
    const updatedEducation = Array.from(this.state.updatedEducation);
    const education = this.state.education
      .filter((_, i) => updatedEducation.includes(i))
      .map((education) => {
        return {
          institution: education.institution,
          education_type: education.education_type,
          city_state: education.city_state,
          country: education.country,
          profile_id: education.profile_id,
          id: education.id ? education.id : undefined,
        };
      });
    updatedEducation.length && this.props.add(education);
    updatedEducation.includes(this.state.education.length - 1) &&
      this.setState({
        education: this.state.education.concat({
          institution: "",
          education_type: "",
          city_state: "",
          country: "",
          profile_id: this.props.profile.id,
        }),
      });

    this.setState({ updatedEducation: new Set() });
  };

  delete = (id) => {
    const newArray = this.state.education.filter((_, i) => i !== id);
    const education = this.state.education.find((_, i) => i === id);
    if (education.id) this.props.delete(education.id);
    this.setState({
      education: newArray,
    });
  };

  handleChange = (event, index) => {
    let { name, value } = event.target;
    let current = this.state.education;
    current[index] = { ...this.state.education[index], ...{ [name]: value } };
    this.setState({
      education: current,
      updatedEducation: this.state.updatedEducation.add(index),
    });
  };

  render() {
    return (
      <div>
        <Title>Education</Title>
        <div className="profile_detail post">
          {this.state.education.map((education, i) => (
            <Row key={i}>
              <Col lg={4}>
                <select
                  id="singleSelect"
                  name="education_type"
                  className="form-control form-control-lg"
                  value={education.education_type}
                  onChange={(e) => this.handleChange(e, i)}
                >
                  <option value="high school">High School</option>
                  <option value="some college">Some College</option>
                  <option value="associates">Associates Degree</option>
                  <option value="bachelors">Bachelor's Degree</option>
                  <option value="masters">Mater's Degree</option>
                  <option value="phd">PHD Degree</option>
                </select>
              </Col>
              <Col lg={3}>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Institution"
                  name="institution"
                  value={education.institution}
                  onChange={(e) => this.handleChange(e, i)}
                />
              </Col>
              <Col lg={2}>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="City, State"
                  name="city_state"
                  value={education.city_state}
                  onChange={(e) => this.handleChange(e, i)}
                />
              </Col>
              <Col lg={2}>
                <TextBox
                  type="text"
                  placeholder="Country"
                  name="country"
                  value={education.country}
                  onChange={(e) => this.handleChange(e, i)}
                />
              </Col>
              {i !== this.state.education.length - 1 && (
                <Col lg={1}>
                  <Button
                    className="fa fa-trash"
                    style={{ cursor: "pointer", marginTop: "1.5rem" }}
                    onClick={() => this.delete(i)}
                  ></Button>
                </Col>
              )}
            </Row>
          ))}
          <HoverButton
            type="button"
            className="btn btn-primary btn_apply white_bg"
            hoverData="Create profile first before adding your work education history"
            hover={!this.props.profile.id}
            disabled={!this.props.profile.id}
            onClick={this.addEducation}
          >
            Add
          </HoverButton>
        </div>
      </div>
    );
  }
}
